import React, {useContext} from "react";
import OrganizationContainerContext from "../OrganizationContainerContext";
import _ from "lodash";
import {BsFillCalendar2DateFill, BsShieldLockFill} from "react-icons/bs";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import getTitle from "../../../../helpers/getTitle";
import {renderIf} from "../../../Shared";
import {renderFromToTime} from "../../../../helpers/datetimeHelpers";
import dayjs from "dayjs";
import useTranslate from "../../../../modules/local/useTranslate";
import {exam_getExaminations_Api} from "../../../../apis";
import renderPagingLoading from "../../../MainPage/functions/renderPagingLoading";
import {bindQueryParams} from "../../functions/routerHelper";
import CustomLazyPaginationWrapper from "../../../../modules/asyncCache/components/CustomLazyPaginationWrapper";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {ExamOutlineSvg} from "../../../../components/Svgs/ExamSvg";
import {ItemInfoWithIcon} from "../../../../components/common/ItemInfoWithIcon";
import {SiderBlockHeader} from "../components/SiderBlockHeader";
import {SiderBlockCard} from "../components/SiderBlockCard";

export const OrganizationExaminations = () => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {organization} = useContext(OrganizationContainerContext)
    const examinations = _.get(organization, 'examinations', [])

    return (
        <CustomLazyPaginationWrapper
            auto={false}
            sample={2}
            apiInfo={exam_getExaminations_Api}
            renderItem={(e, i) => {
                const {time_open, time_close} = e ?? {}
                return (
                    <div key={i} className="px-3 py-2 background-50 hover:scale-2xs hover:shadow-md rounded-xl">
                        {_.get(e, 'privacy') === 2 && (
                            <BsShieldLockFill
                                size={20}
                                className="absolute text-blue-700 opacity-80"
                                style={{top: '0.5rem', right: '0.5rem'}}
                            />
                        )}
                        <Link
                            to={getLinkToDetail(e)}
                            className="font-bold text-base text-color-000 no-underline max-lines-1 mb-1">
                            {getTitle(e)}
                        </Link>
                        {renderIf(
                            _.some([time_open, time_close]),
                            <ItemInfoWithIcon
                                icon={<BsFillCalendar2DateFill size={12} className="mx-1 text-green-500"/>}
                                value={renderFromToTime(time_open, time_close)}
                                className="text-xs italic"
                            />
                        )}
                        <div className="text-right font-semibold text-xs md:text-xs italic">
                            {_.get(e, 'is_expired') === true ? (
                                <span className="text-red-600">{t('close')}</span>
                            ) : dayjs(_.get(e, 'time_open')).isAfter(dayjs()) ? (
                                <span className="text-green-700">{t('upcoming')}</span>
                            ) : (
                                <span className="text-blue-700">{t('opening')}</span>
                            )}
                        </div>
                    </div>
                )
            }}
            renderLoading={renderPagingLoading}
            id={[exam_getExaminations_Api.path, organization?.id, 1].join("/")}
            query={bindQueryParams([{id: organization?.id}, {type: 'organization'}])}
            // hide_expired: chỉ dùng riêng ở widget teaser này (sample=2) - loại hẳn kỳ thi đã đóng
            // khỏi kết quả thay vì chỉ xếp cuối, tránh lọt vào top 2 khi tổ chức chưa đủ 2 kỳ thi
            // đang mở/sắp mở (bug thực tế: kỳ thi "Đóng" vẫn hiện ở đây). Trang quản trị
            // (Workspace/Examination) gọi CHUNG API này nhưng KHÔNG truyền cờ này - vẫn thấy đủ kỳ
            // thi cũ để quản lý, xem báo cáo.
            values={{status: 1, hide_expired: 1}}
            renderWrap={(children, __, count) => {
                return !!count && (
                    <SiderBlockCard>
                        <SiderBlockHeader
                            icon={ExamOutlineSvg}
                            iconBgClassName="bg-secondary-50"
                            iconColorClassName="text-secondary-500"
                            title={t('examinations')}
                        />
                        {children}
                    </SiderBlockCard>
                )
            }}
        />
    )
}